module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_image":"Edit image"},"de":{"edit_image":"Bild bearbeiten"}}')
  delete Component.options._Ctor
}
